import React from "react";
import { Helmet } from "react-helmet-async";
import { Coffee, Heart, ExternalLink } from "lucide-react";

const BMC_URL = "https://buymeacoffee.com/niveshstreet";
const QR_IMAGE = "/img/bmc-qr.webp";

export default function BuyMeCoffee() {
  return (
    <div className="px-4 sm:px-6 lg:px-10 py-10 max-w-[1000px] mx-auto" data-testid="bmc-page">
      <Helmet>
        <title>Buy Us a Coffee · Support Nivesh Street</title>
        <meta name="description" content="Love Nivesh Street? Buy us a coffee and help keep India's independent live market intelligence free for everyone." />
        <meta property="og:title" content="Buy Us a Coffee · Support Nivesh Street" />
        <meta property="og:description" content="Independent, ad-light market intel runs on reader support. Buy us a coffee ☕" />
        <meta property="og:image" content="https://niveshstreet.in/og-social-card.jpg" />
        <link rel="canonical" href="https://niveshstreet.in/support" />
      </Helmet>

      <div className="ns-card p-6 sm:p-10 grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-10 items-center">
        <div>
          <div className="ns-eyebrow mb-3 inline-flex items-center gap-1.5">
            <Heart className="w-3 h-3 text-[#D91E2A]" /> Reader-Supported Newsroom
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight text-[#1A1A1A] mb-4">
            Buy us a coffee ☕
          </h1>
          <p className="text-base sm:text-lg text-[#3A3B3E] leading-relaxed mb-5 max-w-[560px]">
            Nivesh Street is a one-person-and-friends newsroom. No paywall, no clickbait, no pump-and-dump
            Telegram groups — just clean live NSE/BSE data, honest IPO notes, and daily editorial you
            can trust. If something here saved you a bad trade or taught you a thing — a one-time
            coffee goes a long way.
          </p>

          <div className="flex flex-wrap gap-3 items-center mb-6">
            <a
              href={BMC_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#FFDD00] text-[#0A0A0A] text-sm sm:text-base font-bold shadow-md hover:shadow-lg hover:translate-y-[-1px] transition-all"
              data-testid="bmc-primary-cta"
            >
              <Coffee className="w-4 h-4" /> Buy us a coffee
              <ExternalLink className="w-3.5 h-3.5 opacity-60" />
            </a>
            <a
              href={BMC_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs font-mono-fin uppercase tracking-widest text-[#6B6C6F] hover:text-[#D91E2A]"
            >
              or go directly →
            </a>
          </div>

          <ul className="text-sm text-[#6B6C6F] space-y-1.5">
            <li>• 100% of tips fund hosting, market-data licensing, and more writers.</li>
            <li>• We'll never gate articles behind a paywall.</li>
            <li>• We'll shout out generous supporters in our next weekly briefing (opt-in).</li>
          </ul>
        </div>

        <div className="flex flex-col items-center justify-center gap-3 bg-[#FAF8F3] rounded-xl p-5 border border-[#E2DDD3]" data-testid="bmc-qr-block">
          <div className="text-[10px] font-mono-fin uppercase tracking-widest text-[#8C8D90]">Scan to tip</div>
          <img
            src={QR_IMAGE}
            alt="Scan to buy us a coffee"
            className="w-56 h-56 object-contain rounded-lg bg-white p-2 shadow-inner"
            loading="lazy"
          />
          <div className="text-[11px] text-[#6B6C6F] text-center max-w-[220px] leading-snug">
            Open your camera, point at the QR, tap the link — supports UPI, cards & international wallets.
          </div>
        </div>
      </div>
    </div>
  );
}
